import {find, get, has, isObject, isString, orderBy} from 'lodash';

export const appURL = state => { // MLD-8102
  if (isObject(window.ML) && isString(window.ML.appURL)) {
    return window.ML.appURL;
  }
  return null;
}

export const accountManager = state => { // MLD-5199
  return state.accountManager;
}
export const accountManagers = state => { // MLD-5199
  return state.accountManagers;
}
export const activeAccountManagers = (state, getters) => { // MLD-6928
  return getters.accountManagers.filter(user => user.is_active);
}
export const activeUsers = state => { // MLD-1970
  return state.users.filter(u => u.is_active);
};
export const admins = state => {
  const admins = state.users.filter(u => {
    return u.status === 'Active' && u.team?.role === 'Team Admin' && !u.is_employee;
  });
  return orderBy(admins, ['slug'], ['asc']);
};
export const announcements = state => {
  return state.announcements;
};
export const billable = state => {
  return team(state);
};

export const botResult = state => { // MLD-5093
  return state.botResult;
}
export const isBot = state => { // MLD-5093
  return state.botResult?.bot;
}

export const brands = state => { // MLD-4796
  return state.brands;
}
export const canSendEmails = state => { // MLE-36
  return state.currentTeam
    && state.currentTeam.sending_emails_enabled
    && (state.user.team_admin || state.currentTeam.members_can_send_emails);
}
export const contacts = state => {
  return state.contacts;
};
export const csrfToken = state => {
  return state.csrfToken;
};
export const currentEvent = state => {
  return state.currentEvent;
};
export const currentPresentation = state => {
  /*return lodash.find(state.presentations, (p) => {
   return p.id == state.currentPresentationID
   });*/
  return state.currentPresentation;
  //return state.presentations.filter(p => { return p.id === state.currentPresentationID});
};
export const currentUser = state => {
  return state.user;
};
export const defaultShareTemplate = state => {
  return find(state.shareTemplates, t => t.active && t.is_default === true);
};
export const devices = state => {
  return state.devices;
};
export const deviceTypes = state => {
  return state.deviceTypes;
};
export const emailCreditInfo = state => { // MLD-6180
  return state.emailCreditInfo;
};
export const folders = state => {
  return state.folders;
};
export const groups = state => {
  return state.groups;
};
export const hasUnreadAnnouncements = state => {
  return state.announcements.filter((a) => {
    return a.read === 0;
  }).length > 0;
};
export const hasUnreadNotifications = state => {
  return state.notifications.filter((n) => {
    return n.read === 0;
  }).length > 0;
};
export const impersonate = state => { // MLD-1841
  return window.ML.impersonate;
}
export const importUsers = state => {
  return state.importUsers;
};
export const labels = state => {
  return state.labels;
};
export const locales = state => { // MLD-1323
  return state.locales;
};
export const isMobile = state => {
  return $(window).width() < 768;
};
export const notifications = state => {
  return state.notifications;
};
export const permissions = state => { // MLD-5518
  return state.permissions;
}
export const activePresentations = state => {
  return state.presentations.filter(p => p.active)
};
export const presentations = state => {
  return state.presentations;
};
export const presentationStatusCodes = state => {
  return state.presentationStatusCodes;
};
export const presentationTypes = state => {
  return state.presentationTypes;
};
export const products = state => { // MLD-3306
  return state.products;
}
export const query = state => { // MLD-2035
  return state.query;
}
export const reloadRequired = state => { // // MLD-915
  return state.reloadRequired;
};
export const spark = state => {
  return state.spark;
};
export const shareTemplates = state => {
  return state.shareTemplates;
};
export const quickShareTemplates = state => { // MLD-3865
  return state.shareTemplates.filter(t => t.is_quick_share);
};
export const defaultShareTheme = state => { // MLD-967
  return find(state.shareThemes, t => t.is_default); // MLD-3702
};
export const shareThemes = state => { // MLD-967
  return state.shareThemes;
};
export const sidebarOpen = state => {
  return state.sidebarOpen;
};
export const team = state => {
  return state.currentTeam;
};
export const teams = state => {
  return state.teams;
};
export const teamRoles = state => {
  return state.team_roles;
};
export const triggerEvents = state => {
  return state.triggerEvents;
};
export const timezones = state => {
  return state.timezones;
};
export const title = state => {
  return state.title;
};
export const user = state => {
  return state.user;
};
export const isAdmin = state => { // MYC-2357
  return state.user && state.user.team_admin;
};
export const isMember = state => { // MYC-2357
  return state.user && state.user.team_member;
};
export const isEmployee = state => {
  return state.user && state.user.is_employee;
}
export const loadingUsers = state => state.loadingUsers; // MLD-3690
export const users = state => {
  return state.users;
};
export const userStatusCodes = state => {
  return state.userStatusCodes;
};
export const webhooks = state => {
  return state.webhooks;
};

export const canTeamUseSpaces = (state, getters) => { // MLD-5030
  return getters?.team?.spaces_enabled;
}

export const canTeamUseHaystack = (state, getters) => { // MLD-7250
  return getters?.team?.haystack_enabled;
}

export const canUserCreateSpaces = (state, getters) => { //  MLD-5030
  return getters?.canTeamUseSpaces
    && getters?.user?.can_create_spaces;
}

export const canUserShareSpaces = (state, getters) => { //  MLD-5030
  return getters?.canTeamUseSpaces
    && getters?.user?.can_share_spaces;
}

export const canTeamUseSnippets = (state, getters) => { // MLD-3900
  return getters.team
    && getters.team.sharing_enabled
    && getters.team.sending_emails_enabled
    && getters.team.members_can_send_emails
    && getters.team.snippets_enabled;
};

export const canUseSinch = (state, getters) => { // MLD-7744
  return getters.team?.sinch_enabled;
};

export const canUseSnippets = (state, getters) => { // MLD-3900
  return getters.canTeamUseSnippets
    && getters.user
    && getters.user.is_full_user
    && getters.user.can_use_snippets;
};

export const canVerifyEmails = (state, getters) => { // MLD-6016
  return getters.team?.email_verification_enabled
    && getters.user
    && getters.user.is_full_user
    && getters.user.can_verify_emails;
};

export const faxingEnabled = (state, getters) => { // MLD-3982
  return getters.team
    && getters.team.fax_enabled;
}

export const canSendFaxes = (state, getters) => { // MLD-3982
  return getters.faxingEnabled
    && getters.user
    && getters.user.is_full_user;
}

export const canTeamUseMetabase = (state, getters) => { // MLD-4575
  return window.ML
    && !!window.ML.metabaseEnabled
    && getters.team
    && getters.team.metabase_enabled;
}
export const canUseMetabase = (state, getters) => { // MLD-4575
  return getters.canTeamUseMetabase
    && getters.user
    && getters.user.can_use_metabase;
};

export const hasPermission = (state) => (key) => { // MLD-5518
  return (state && isObject(state.permissions) && has(state.permissions, key))
    ? get(state.permissions, key)
    : false;
}
export const canEditBrands = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_brands');
}
export const canEditDevices = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_devices');
}
export const canEditEmailTemplates = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_email_templates');
}
export const emailPreviewsEnabled = (state, getters) => { // MLD-4550
  return getters.team
    && getters.team.email_previews_enabled;
}
export const canTestEmailTemplates = (state, getters) => { // MLD-4550
  return getters.emailPreviewsEnabled
    && getters.hasPermission('can_test_email_templates');
}
export const canEditEvents = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_events');
}
export const canEditFaxes = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_faxes');
}
export const canEditFiles = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_files');
}
export const canEditFolders = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_folders');
}
export const canEditForms = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_forms');
}
export const canEditGroups = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_groups');
}
export const canEditLabels = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_labels');
}
export const canEditMessages = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_messages');
}
export const canEditMetabasePermissions = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_metabase_permissions');
}
export const canEditPresentations = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_presentations');
}
export const canEditProducts = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_products');
}
export const canEditSubscribers = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_subscribers');
}
export const canEditTeam = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_team');
}
export const canEditTerritories = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_territories');
}
export const canEditUserContacts = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_user_contacts');
}
export const canEditUsers = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_users');
}
export const canEditWebhooks = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_edit_webhooks');
}
export const canExportData = (state, getters) => { // MLD-5518
  return getters.hasPermission('can_export_data');
}

